// "Live Activity" — agent ne abhi-abhi kya kiya (lead aayi, call hui, booking).
// Har row: tick wala box | patli khadi line | kya hua | kab hua.
import React, { useState } from "react";
import styles from "./PounceLiveActivity.module.css";
import { formatActivityTime } from "../../../utils/pounceAgentHelpers";

// Shuru me itni rows; baaki "View All" se khulti hain.
const COLLAPSED_COUNT = 5;

// `timeZone` = business (agent) ka timezone; na ho to device ka.
const PounceLiveActivity = ({ activity = [], timeZone }) => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? activity : activity.slice(0, COLLAPSED_COUNT);

  return (
    <section className={styles.section} aria-labelledby="pounce-activity-title">
      <div className={styles.head}>
        <h3 id="pounce-activity-title" className={styles.title}>
          Live Activity
        </h3>
        {activity.length > COLLAPSED_COUNT && (
          <button type="button" className={styles.viewAll} onClick={() => setShowAll((v) => !v)}>
            {showAll ? "Show less" : "View All"}
          </button>
        )}
      </div>

      {visible.length === 0 ? (
        <div className={styles.empty}>
          <p className={styles.emptyTitle}>No activity yet</p>
          <p className={styles.emptyText}>
            When a lead comes in, Outbound Caller calls it within 10 seconds and it shows up here.
          </p>
        </div>
      ) : (
        <ul className={styles.list}>
          {visible.map((e) => (
            <li key={e.id} className={styles.row}>
              <span className={styles.check} aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12.5l4.5 4.5L19 7.5"
                    stroke="#6524EB"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className={styles.divider} aria-hidden="true" />
              <span className={styles.text}>
                <span className={styles.label}>{e.label}</span>
                {e.who && <span className={styles.who}>{e.who}</span>}
              </span>
              <time className={styles.time} dateTime={e.at}>
                {formatActivityTime(e.at, timeZone)}
              </time>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default PounceLiveActivity;
